import z from "zod";
import {
  dateOperatorSchema,
  numberOperatorSchema,
  stringOperatorSchema,
} from "../operations/operation-filter";

export const filterWithdrawalSchema = z.object({
  status: stringOperatorSchema.optional(),
  userId: stringOperatorSchema.optional(),
  reference: stringOperatorSchema.optional(),
  demandDate: dateOperatorSchema.optional(),
  decisionDate: dateOperatorSchema.optional(),
  amount: numberOperatorSchema.optional(),
});

export type FilterWithdrawalType = z.infer<typeof filterWithdrawalSchema>;
